import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const TotalBudget = styled.span`
  font-size: 11px;
  color: #7a89f4;
`;

export const BoostButton = styled.button`
  display: inline-flex;
  padding: 1px 12px 2px 12px;
  align-items: center;
  border-radius: 25px;
  background-color: ${({ theme }) => theme.colors.dataViz.boostButtonBgColor};
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.dataViz.boostButtonTextColor};
  font-size: 11px;
  font-weight: 600;
  height: 20px;
  transition: ease-in-out 0.3s;
  line-height: 0;
  &:hover {
    transform: scale(1.1);
  }
`;
